import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const FAQ_KEYS_MAP: Record<string, number[]> = {
    default: [1, 2, 3, 4, 5, 6],
    au: [2, 3, 4, 5, 6],
};

const FAQ_LINK_MAP: Record<string, Partial<Record<'a2' | 'a4', string>>> = {
    au: {
        a2: 'https://www.ecoflow.com/au/series/power-solutions',
        a4: 'https://au.ecoflow.com/products/glacier-classic-portable-fridge-freezer',
    },
};

export default function O() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const links = FAQ_LINK_MAP[locale] || {};
    const allLists: any = [
        {
            title: t('secO_q1'),
            desc: t.rich('secO_a1', {
                a1: (text: string) => (
                    <Link
                        href={`https://${locale}.ecoflow.com/products/river-${['nl']?.includes(locale) ? '3' : '2'}-portable-power-station`}
                        className="a-link"
                    >
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secO_q2'),
            desc: t.rich('secO_a2', {
                a1: (text: string) => (
                    <Link href={links.a2 || `https://${locale}.ecoflow.com/pages/portable-power-stations`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secO_q3'),
            desc: t.rich('secO_a3', {
                a1: (text: string) => (
                    <Link
                        href={`https://${locale}.ecoflow.com/products/river-${['nl']?.includes(locale) ? '3' : '2'}-portable-power-station`}
                        className="a-link"
                    >
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secO_q4'),
            desc: t.rich('secO_a4', {
                a1: (text: string) => (
                    <Link href={links.a4 || `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secO_q5'),
            desc: t.rich('secO_a5', {
                a1: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/products/delta-2-max-portable-power-station`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secO_q6'),
            desc: t('secO_a6'),
        },
    ];

    const keys = [...(FAQ_KEYS_MAP[locale] || FAQ_KEYS_MAP.default)];

    if (['de', 'fr', 'kr'].includes(locale)) {
        keys.pop();
    }

    const lists: any = keys.map((num) => allLists[num - 1]);

    return (
        <div id="outdoor-recreation-O" className={`outdoor-recreation-O ${css['outdoor-recreation-O']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secO_title')}</p>
                </div>
                <Collapse
                    ghost={true}
                    className="collapse-lists"
                    defaultActiveKey={0}
                    expandIcon={({ isActive }: any) => (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                    expandIconPosition="right"
                >
                    {lists?.map((list: any, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.desc}</p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </div>
    );
}
